export default "__VITE_ASSET__sjPaevhs__"